import { Injectable } from '@angular/core';
import { UnpStatus } from '$shared/components/unp-status/unpStatus';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class UnpStatusService {
  constructor(private http: HttpClient) {}

  public getStatus(unp: string) {
    return this.http.get<UnpStatus>('/v1/validate-unp', {
      params: { unp: unp },
    });
  }
}
